import React, { FunctionComponent } from "react";

const MultipleActionsChatIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/users/geomertic-close-up-multiple-users-actions/multiple-actions-chat
  return (
    <svg viewBox="-0.25 -0.25 24.5 24.5" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.75,20.25h-3l-4.5,3v-3h-1.5a1.5,1.5,0,0,1-1.5-1.5v-6a1.5,1.5,0,0,1,1.5-1.5h9a1.5,1.5,0,0,1,1.5,1.5v6A1.5,1.5,0,0,1,21.75,20.25Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M14.25 14.25L20.25 14.25"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M14.25 17.25L20.25 17.25"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M9.1,9.264A5.251,5.251,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.259-2.594"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M13.723 3.375 A2.625 2.625 0 1 0 18.973 3.375 A2.625 2.625 0 1 0 13.723 3.375 Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M20.245,9a4.5,4.5,0,0,0-7.285-.71"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default MultipleActionsChatIcon;
